var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    {
      ref: "trigger",
      staticClass: "gh-prompt-popover",
      on: { mouseenter: _vm.onEnter, mouseleave: _vm.scheduleHide },
    },
    [
      _c("span", { staticClass: "gh-prompt-popover__text" }, [
        _vm._v(_vm._s(_vm.text)),
      ]),
      _vm._v(" "),
      _vm.interactive
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.visible && _vm.hasContent,
                  expression: "visible && hasContent",
                },
              ],
              ref: "popup",
              staticClass: "gh-prompt-popover__popup",
              class: {
                "gh-prompt-popover__popup--tooltip": _vm.tooltip,
                "gh-prompt-popover__popup--above": _vm.placement === "above",
                "gh-prompt-popover__popup--below": _vm.placement === "below",
              },
              style: _vm.popupStyle,
              attrs: { role: "tooltip" },
              on: { mouseenter: _vm.onEnter, mouseleave: _vm.scheduleHide },
            },
            [_vm._v(_vm._s(_vm.text))]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }